var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    attrs: {
      "hide-header": "",
      "hide-footer": "",
      "centered": "",
      "no-close-on-backdrop": "",
      "lazy": "",
      "size": "xl"
    },
    model: {
      value: _vm.showDialog,
      callback: function ($$v) {
        _vm.showDialog = $$v;
      },
      expression: "showDialog"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": _vm.alert.show
    }
  }, [_vm._v(" " + _vm._s(_vm.alert.message) + " ")]), _c('b-row', {
    staticClass: "mb-4",
    attrs: {
      "align-h": "between"
    }
  }, [_c('b-col', {
    staticClass: "tw-flex tw-items-center tw-gap-4",
    attrs: {
      "cols": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon_logo_violet.svg"),
      "alt": ""
    }
  }), _c('h2', {
    staticClass: "h2 heading mb-0"
  }, [_vm._v("New Patient Reassignment")])]), _c('b-col', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "tw-text-eclipse",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function ($event) {
        _vm.showDialog = false;
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x-circle",
      "font-scale": "1.5"
    }
  })], 1)])], 1), _c('div', {
    staticClass: "tw-flex tw-min-h-0 tw-flex-1 tw-flex-col",
    staticStyle: {
      "min-height": "560px"
    }
  }, [_c('section', {
    staticClass: "tw-mb-8 tw-shrink-0 tw-border-b tw-border-gray-200 tw-pb-8"
  }, [_c('div', {
    staticClass: "tw-grid tw-gap-8",
    class: _vm.reassignmentType === 'TEMPORARY' ? 'tw-grid-cols-4' : 'tw-grid-cols-3'
  }, [_c('div', [_c('label', {
    staticClass: "text-primary text-small tw-mb-2 tw-block"
  }, [_vm._v(" Reassignment Type ")]), _c('b-form-select', {
    attrs: {
      "options": _vm.reassignmentTypeOptions
    },
    model: {
      value: _vm.reassignmentType,
      callback: function ($$v) {
        _vm.reassignmentType = $$v;
      },
      expression: "reassignmentType"
    }
  })], 1), _c('DateControls', {
    attrs: {
      "reassignment-type": _vm.reassignmentType
    },
    on: {
      "change": _vm.onDatesChange
    }
  }), _c('div', [_c('label', {
    staticClass: "text-primary text-small tw-mb-2 tw-block"
  }, [_vm._v(" Request Reason ")]), _c('b-form-select', {
    attrs: {
      "options": _vm.reasonCategoryOptions
    },
    model: {
      value: _vm.reasonCategory,
      callback: function ($$v) {
        _vm.reasonCategory = $$v;
      },
      expression: "reasonCategory"
    }
  })], 1)], 1), _vm.reasonCategory === 'Other' ? _c('div', {
    staticClass: "tw-mt-4"
  }, [_c('label', {
    staticClass: "text-primary text-small tw-mb-2 tw-block"
  }, [_vm._v(" Details ")]), _c('b-form-textarea', {
    ref: "reasonDetailsInput",
    attrs: {
      "placeholder": "Describe the reason...",
      "maxlength": "300",
      "rows": "3"
    },
    model: {
      value: _vm.reasonDetails,
      callback: function ($$v) {
        _vm.reasonDetails = $$v;
      },
      expression: "reasonDetails"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "tw-mt-6"
  }, [_c('SourceDoctorSelector', {
    attrs: {
      "panel-summary": _vm.panelSummary,
      "loading-summary": _vm.loadingPanelSummary
    },
    on: {
      "select": _vm.onSourceDoctorSelect,
      "error": _vm.onChildError
    }
  })], 1)]), _c('div', {
    staticClass: "reassignment-grid tw-min-h-0 tw-flex-1 tw-gap-4 tw-gap-x-8"
  }, [_c('SourceStateList', {
    staticClass: "tw-min-w-0",
    staticStyle: {
      "grid-area": "states"
    },
    attrs: {
      "source-doctor": _vm.sourceDoctor,
      "panel-summary": _vm.panelSummary,
      "loading-summary": _vm.loadingPanelSummary
    },
    on: {
      "change": _vm.onStatesChange,
      "error": _vm.onChildError
    }
  }), _c('RecipientDoctorList', {
    staticClass: "tw-contents",
    attrs: {
      "selected-states": _vm.selectedStates,
      "source-doctor": _vm.sourceDoctor,
      "state-counts": _vm.statePatientCounts,
      "source-panel-total": _vm.sourcePanelTotal,
      "reassignment-type": _vm.reassignmentType,
      "start-timestamp": _vm.startTimestamp,
      "end-timestamp": _vm.endTimestamp
    },
    on: {
      "change": _vm.onRecipientChange,
      "error": _vm.onChildError
    }
  })], 1), _c('div', {
    staticClass: "tw-shrink-0 tw-border-t tw-border-gray-200"
  }, [_c('TransferSummaryBar', {
    attrs: {
      "status-message": _vm.footerCaption,
      "can-submit": _vm.canSubmit,
      "submitting": _vm.submitting
    },
    on: {
      "cancel": function ($event) {
        _vm.showDialog = false;
      },
      "submit": _vm.openConfirmDialog
    }
  })], 1)]), _c('ConfirmTransferDialog', {
    ref: "ConfirmTransferDialog",
    attrs: {
      "reassignment-type": _vm.reassignmentType,
      "source-doctor-label": _vm.sourceDoctorLabel,
      "start-timestamp": _vm.startTimestamp,
      "end-timestamp": _vm.endTimestamp,
      "reason-label": _vm.reasonLabel,
      "states-count": _vm.selectedStates.length,
      "doctors-count": _vm.recipientIds.length,
      "total-to-transfer": _vm.reduceTargetCount,
      "submit-body": _vm.submitBody
    },
    on: {
      "submitted": _vm.onTransferConfirmed
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };